type FlatRoute = { [key: string]: string };
type NestedRoutes = { [key: string]: string | NestedRoutes };

const routes = {
  login: '/login',

  empty: '/',

  users: include('/users/', {
    self: '',
    invite: 'invite',
    permissions: ':userId/:tab?',
  }) as FlatRoute,
};

export default routes;

function include(base: string, routes: NestedRoutes) {
  const mappedRoutes: NestedRoutes = {};
  Object.keys(routes).forEach((route) => {
    const url = routes[route];
    if (typeof url === 'object') {
      mappedRoutes[route] = include(base, url);
    } else {
      mappedRoutes[route] = url.indexOf('/') === 0 ? url : [base, url].join('/').replace('//', '/');
    }
  });

  // The resulting map should only contain
  return mappedRoutes;
}

export const baseRoute = '/account';
